<script>
  import formatDate from "@/utils/date/format";
  import mixin from "../../mixin";

  export default {
    mixins: [mixin],
    data() {
      return {};
    },
    computed: {
      content() {
        return this.notification.content;
      },
      formattedMonth() {
        const options = {
          year: "numeric",
          month: "short",
        };
        return formatDate({ date: this.content.month, options });
      },
    },
    methods: {},
  };
</script>
<template>
  <div class="p-base-medium text-neutral-400 m-b-9">
    <span class="m-r-3">{{
      $t(`notifications.${notification.type}.targetsAreSet`)
    }}</span>
    <span class="text-neutral-900 m-r-3">{{ content.partnersCount }}</span>
    <span class="m-r-3">{{ $t(`notifications.${notification.type}.numOfPartners`) }}</span>
    <span class="text-neutral-900 m-r-3">{{ formattedMonth }}</span>
  </div>
</template>
